import { compose, prop } from 'ramda';

const getPromptRoot = prop('prompt');

export const getPromptDialogSelector = getPromptRoot;
export const getIsOpenPromptSelector = compose(prop('open'), getPromptRoot);

export const getIsMenuOpenSelector = compose(prop('menuOpen'), getPromptRoot);
